import { useAppSelector } from "../../store"
import { getOptions } from "../store/selectors"

const optionsQuery = {}

export const useAllOptions = () => {
  const options = useAppSelector((s) => getOptions(s, optionsQuery))
  return { options }
}
